import { BalancePaymentTranslations } from "./balancePaymentTranslations.types";

const balancePaymentUkTranslations: BalancePaymentTranslations = {
    balancePaymentPage: {
        title: "Balance Payment",
        loading: "Loading payment information...",
        processing: "Processing your payment...",
        processingDescription: "Please wait while we confirm your payment.",
        successTitle: "Payment successful!",
        successDescription: "Your balance payment has been processed successfully.",
        errorTitle: "Payment could not be completed",
        errorDescription: "Something went wrong processing your payment. Please try again later.",
        fullyPaidTitle: "All payments are up to date",
        fullyPaidDescription: "There are no outstanding balance payments for this booking.",
        noBookingReference: "No booking reference provided.",
        bookingReference: "Booking Reference",
        departure: "Departure",
        returnDate: "Return",
        totalPrice: "Total Price",
        amountPaid: "Amount Paid",
        balanceDue: "Balance Due",
        amountToPay: "Amount to pay: {amount}",
        paymentModeTitle: "Choose your payment option",
        payNextPayment: "Pay next instalment",
        payFullBalance: "Pay full balance",
    },
};

export default balancePaymentUkTranslations;
